import { User } from '@/models/User';

export class Guest extends User {
  protected $name: string = 'Guest';
  protected $fillable: string[] = [];

  protected filters: object = {
    role: 'guest',
  };

  public id?: string;
  public name?: string;
  public created_at?: string;
  public updated_at?: string;

  public url() {
    return '/users/' + this.id;
  }
}
